import React, { FC } from 'react';
import { MobileExpandedWrapper } from './MobileWrapper';
import { CombinedFiltersSearchMobileWrapper } from './CombinedFiltersSearchMobileWrapper';
import { useScreenBreakpoint } from 'consts/breakpoints';


interface MobileWrapperSwitchProps {
  onClose: () => void;
  onCommit: () => void;
  onReset: () => void;
}

export const MobileWrapperSwitch: FC<MobileWrapperSwitchProps> = props => {
  const { children, onClose, onReset, onCommit } = props;
  const isCombinedFiltersView = useScreenBreakpoint() < 3;

  const WrapperComponent = isCombinedFiltersView ? CombinedFiltersSearchMobileWrapper : MobileExpandedWrapper;

  return (
    <WrapperComponent onClose={onClose} onReset={onReset} onCommit={onCommit}>
      {children}
    </WrapperComponent>
  );
};


